/**
 * 空元組類型
 * Empty Tuple Type
 * 
 * 提供空元組相關的類型定義
 * Provides empty tuple-related type definitions
 */

import { ITSArrayListMaybeReadonly } from '../base';

/**
 * 空元組類型
 * Empty tuple type
 * 
 * @example
 * type Empty = ITSEmptyTuple;
 * // type Empty = [] | readonly []
 */
export type ITSEmptyTuple = ITSArrayListMaybeReadonly<never>;
